module.exports = __webpack_public_path__ + "img/08b3f2e0-d687-11e8-828a-1334c9ae6ae8-image.e7ccf1d6.jpg";